import { render, staticRenderFns } from "./ScoresSorting.vue?vue&type=template&id=4991b255&scoped=true&"
import script from "./ScoresSorting.vue?vue&type=script&lang=js&"
export * from "./ScoresSorting.vue?vue&type=script&lang=js&"
import style0 from "./ScoresSorting.vue?vue&type=style&index=0&id=4991b255&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4991b255",
  null
  
)

export default component.exports